import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { update } from "../../../state/bordersSlice";
import { Button, makeStyles } from "@fluentui/react-components";
import { LineTypeSolid } from "../../../assets/icons";

const useClasses = makeStyles({
  Header: {
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700,
    lineGeight: 11.5,
    textAlign: "left",
  },
  PanelButton: {
    justifyContent: "left",
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 400,
    letterSpacing: "0.02em",
  },
  AccordionHeader: {
    "& > button": {
      minHeight: 0,
    },
  },
});

const BorderWeightMenuItem = () => {
  const classes = useClasses();
  const { t } = useTranslation();
  const selection = useSelector((state) => state.selection.borders[0]);
  const selectedBorder = useSelector((state) => state.gridd.present.borders.find((b) => b.id === selection.id));
  const dispatch = useDispatch();

  return (
    <div>
      <div style={{ display: "grid", gridTemplateRows: "auto auto auto" }}>
        <Button
          id="thin"
          icon={<LineTypeSolid style={{ height: 10 }} />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, weight: 1 }));
          }}
        >
          {t("menu.border.weight.thin")}
        </Button>
        <Button
          id="normal"
          icon={<LineTypeSolid style={{ height: 14 }} />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, weight: 2 }));
          }}
        >
          {t("menu.border.weight.normal")}
        </Button>
        <Button
          id="thick"
          icon={<LineTypeSolid style={{ height: 18 }} />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, weight: 3 }));
          }}
        >
          {t("menu.border.weight.thick")}
        </Button>
        <Button
          id="extrathick"
          icon={<LineTypeSolid style={{ height: 22 }} />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, weight: 4 }));
          }}
        >
          {t("menu.border.weight.extrathick")}
        </Button>
      </div>
    </div>
  );
};

export default BorderWeightMenuItem;
